module.exports = __webpack_public_path__ + "static/media/icon-checklist.f3c73b42.svg";